module.exports = __webpack_public_path__ + "static/media/computers1.b66e07dd.png";